/**
 * Created by tschrader on 13.04.2017.
 */

// int casting function required for HTML-1253: preventing commavalues for integer variables

export function int(value: number | string): number {

    if (typeof value === "string" && isHex(value)) {
        return parseInt(value.substring(1), 16);
    }

    const result = Number(value);
    return isNaN(result) ? 0 : Math.trunc(result);
}

function isHex(str: string): boolean {
    let hex = /^#[0-9A-F]{6}$/i;
    return hex.test(str);
}
